import React from "react";
import { useLocation } from "react-router-dom";
import { EnvironmentOutlined, PhoneOutlined } from "@ant-design/icons";
import GoToHome from "../../Components/GoToHome";

function Address() {
  const location = useLocation();
  const props = location.state || {};

  return (
    <div style={{ padding: "60px 16px 20px", minHeight: "100vh" }}>
      <GoToHome />

      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 4px 16px -2px rgba(0, 0, 0, 0.05)",
          padding: "20px",
          marginTop: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
          <div
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "10px",
              background: "#fee2e2",
              color: "#d9363e",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
            }}
          >
            <EnvironmentOutlined />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
              {props.restaurant ? "Restaurant Address" : "Delivery Location"}
            </h3>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "13.5px" }}>
          <div>
            <strong style={{ color: "#64748b", display: "block", fontSize: "12px", marginBottom: "2px" }}>
              ADDRESS
            </strong>
            <span style={{ color: "#0f172a", fontWeight: "500" }}>{props.address || "Not specified"}</span>
          </div>

          {!props.restaurant && props.landmark && (
            <div>
              <strong style={{ color: "#64748b", display: "block", fontSize: "12px", marginBottom: "2px" }}>
                LANDMARK
              </strong>
              <span style={{ color: "#0f172a", fontWeight: "500" }}>{props.landmark}</span>
            </div>
          )}

          {props.orderStatus && props.phone && (
            <div>
              <strong style={{ color: "#64748b", display: "block", fontSize: "12px", marginBottom: "2px" }}>
                CONTACT PHONE
              </strong>
              <a
                href={`tel:${props.phone}`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#d9363e",
                  fontWeight: "700",
                }}
              >
                <PhoneOutlined />
                {props.phone}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Address;
